import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { HistoryRepository } from '@/domain/repositories/history/historyRepository'

export class GetUserJudgeHistoryUseCase {
  constructor(private repository: HistoryRepository) {}

  async getUserJudgeHistory(userId: string, problemId: string, pageIndex: number): Promise<JudgeRecord[]> {
    try {
      const data = await this.repository.getUserJudgeHistory(userId, problemId, pageIndex)
      return data
    } catch (error) {
      console.error(`Error in GetSolutionWithRatingUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
